var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:this.$parent.status === 'accept' ? 'myflex_wMap cover min-pb' : 'myflex cover min-pb'},[_c('Map'),_c('aboutContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }